import { Media, IMedia } from './index'

export interface IArticle {
  _id: string
  slug: string

  title: string
  excerpt: string
  content: string
  image: IMedia | null

  priority: number
  isShowcased: boolean
  
  owner: string

  createdAt: Date
  updatedAt: Date
}

export interface Article extends IArticle {}

export class Article implements IArticle {
  image: Media

  constructor(props: IArticle) {
    Object.assign(this, {
      ...props,
      image: props.image ? new Media(props.image) : null,
    })
  }
}